import React from 'react';
import { createTheme } from '@mui/material/styles';

// import MuiThemeProvider from '@mui/material/styles/MuiThemeProvider';

// const themes = {
//     light: {
//         foreground: '#000000',
//         background: '#eeeeee',
//         color: 'red'
//     },
//     dark: {
//         foreground: '#ffffff',
//         background: '#222222',
//         color: 'green'
//     },
// };

// const theme = createMuiTheme({
//     palette: {
//         mode: 'light'
//     },
//     typography: {
//         button: {
//             fontSize: '1rem',
//         },
//     },
// });
// const Context = React.createContext({
//     theme: theme,
//     // toggle: () => {}
// });
const ContextMuiTheme = React.createContext({
    theme: createTheme({})
});
export default ContextMuiTheme;
